export default __webpack_public_path__ + "static/media/realmhunterlogo.7c6abd9c.png";